import React from 'react';
import styled from 'styled-components';

const ResumeButton2 = ({text}) => {
  return (
    <StyledWrapper>
      <button className="animated-button">
        <Arrow className="arr-2" />
        <span className="text">{text}</span>
        <span className="circle" />
        <Arrow className="arr-1" />
      </button>
    </StyledWrapper>
  );
}

const Arrow = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M4 2H14L20 8V22H4V2Z" />
  <line x1="6" y1="10" x2="12" y2="10" />
  <line x1="6" y1="14" x2="18" y2="14" />
  <line x1="6" y1="18" x2="18" y2="18" />
  <path d="M14 2V8H20" />
</svg>
);

const StyledWrapper = styled.div`
  .animated-button {
    position: relative;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 36px;
    border: 4px solid white; /* White border */
    font-size: 16px;
    background-color: white; /* White background */
    border-radius: 100px;
    font-weight: 600;
    color: black; /* Black text */
    box-shadow: 0 0 0 2px black;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
    width: auto;
    max-width: 220px;
    margin: 0 auto;
  }

  .animated-button svg {
    position: absolute;
    width: 24px;
    fill: black; /* Black icons */
    z-index: 9;
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .arr-1 {
    right: 16px;
  }

  .arr-2 {
    left: -25%;
  }

  .circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    background-color: black; /* Circle color */
    border-radius: 50%;
    opacity: 0;
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .text {
    position: relative;
    z-index: 1;
    transform: translateX(-12px);
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .animated-button:hover {
    box-shadow: 0 0 0 12px transparent;
    background-color: transparent; /* Transparent background on hover */
    color: white; /* White text on hover */
    border-color: white; /* White border on hover */
    border-radius: 12px;
  }

  .animated-button:hover .arr-1 {
    right: -25%;
  }

  .animated-button:hover .arr-2 {
    left: 16px;
  }

  .animated-button:hover .text {
    transform: translateX(12px);
    color: white; /* White text color on hover */
  }

  .animated-button:hover svg {
    fill: white; /* White icon color on hover */
  }

  .animated-button:active {
    transform: scale(0.95);
    box-shadow: 0 0 0 4px white;
  }

  .animated-button:hover .circle {
    width: 220px;
    height: 220px;
    opacity: 1;
  }

  /* Media Queries for Responsiveness */
  @media (max-width: 768px) {
    .animated-button {
      padding: 10px 24px;
      font-size: 14px;
      width: 100%;
      max-width: 180px;
    }

    .animated-button svg {
      width: 20px;
    }

    .animated-button .text {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    .animated-button {
      padding: 8px 20px;
      font-size: 12px;
      max-width: 160px;
    }
.arr-1 {
    right: 8px;
  }
    .animated-button svg {
      width: 18px;
    }

    .animated-button .text {
      font-size: 12px;
    }
  }
`;

export default ResumeButton2;
